export default {
  'attachment': {
    'title': 'Attachment',

    'search_keywords': 'enter keywords',
    'search_status': 'Status',
    'search_btn': 'Search',
    'search_open': 'Open',
    'search_close': 'Close',
    'search_asc': 'Asc',
    'search_desc': 'Desc',

    'name': 'Name',
    'size': 'Size',
    'type': 'Type',
    'create_time': 'CreateTime',
    'status': 'Status',
    'open': 'Open',
    'close': 'Close',
    'action': 'Actions',
    'detail': 'Detail',
    'download': 'Download',
    'delete': 'Delete',
    'attachment_detail': 'Attach detail',

    'detail_id': 'ID',
    'detail_belong_type': 'Belong',
    'detail_name': 'Name',
    'detail_path': 'Path',
    'detail_mime': 'Mime',
    'detail_type': 'Type',
    'detail_size': 'Size',
    'detail_md5': 'Md5',
    'detail_sha1': 'Sha1',
    'detail_driver': 'Driver',
    'detail_url': 'URL',
    'detail_status': 'Status',
    'detail_update_time': 'LastTime',
    'detail_update_ip': 'LastIp',
    'detail_create_time': 'CreateTime',
    'detail_create_ip': 'CreateIp',

    'download_tip': 'please select download file',

    'delete_tip_title': 'Tip',
    'delete_tip_content': 'You will delete the file?',
    'delete_tip_ok': 'Confirm',
    'delete_tip_cancel': 'Cancel'
  }
}
